"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmail = void 0;

var getEmail = function getEmail(state) {
  return state.contact.email;
};

exports.getEmail = getEmail;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/Contact.js
// module id = 141
// module chunks = 0